// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".parent[data-v-06c76f33]{display:-webkit-box;display:-ms-flexbox;display:flex;height:calc(100vh - 56px)}#site[data-v-06c76f33]{margin-left:30%;width:70%}", ""]);
// Exports
module.exports = exports;
